// Template293: Bali - Día con listBox primero (Page11/Page13-style)
// Cabecera, hero, intro, listBox (opcional sticker+tip), bloques (opcional sabiasQue), footerBox, sticker + tip.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template293 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const heroTitle = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const logoImage = getCanvasImageUrl("logo");
	const listBox = page?.data?.listBox;
	const listBoxStickerId = page?.data?.listBoxStickerId;
	const listBoxTip = page?.data?.listBoxTip;
	const listBoxSticker = listBoxStickerId
		? getImageSrc(listBoxStickerId)
		: null;
	const blocks = Array.isArray(page?.data?.blocks) ? page.data.blocks : [];
	const yellowBox = page?.data?.yellowBox;
	const topTipBox = page?.data?.topTipBox;
	const topStickerId = page?.data?.topStickerId;
	const topSticker = topStickerId ? getImageSrc(topStickerId) : null;
	const footerBox = page?.data?.footerBox;
	const footerStickerId = page?.data?.footerStickerId;
	const footerTip = page?.data?.footerTip;
	const footerSticker = footerStickerId ? getImageSrc(footerStickerId) : null;
	const actualHeaderColor = headerBackgroundColor || "#2F6B4F";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
		marginTop: 1,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
						/>
					)}
					{heroTitle && (
						<Box
							component="span"
							sx={{
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
							dangerouslySetInnerHTML={{ __html: heroTitle }}
						/>
					)}
				</Box>
			)}

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginTop: "-7px" }}>
						{intro}
					</Box>
				)}
				{(topTipBox?.text || topSticker) && (
					<Box
						sx={{
							position: "relative",
							minHeight: topSticker ? 80 : 0,
							marginBottom: topSticker ? 3 : 0,
						}}
					>
						{topTipBox?.text && (
							<Box
								sx={{
									position: "absolute",
									bottom: -50,
									right: 90,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0 16px",
									padding: "10px 12px",
									fontSize: 11,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 300,
									zIndex: 3,
								}}
							>
								{topTipBox.text}
							</Box>
						)}
						{topSticker && (
							<Box
								component="img"
								src={topSticker}
								alt=""
								sx={{
									width: 110,
									position: "absolute",
									bottom: -100,
									right: 0,
									zIndex: 2,
								}}
							/>
						)}
					</Box>
				)}
				{listBox &&
					listBox.titulo &&
					Array.isArray(listBox.items) &&
					listBox.items.length > 0 && (
						<Box data-block-id="text-2" sx={{ position: "relative", marginTop: 0.5 }}>
							<Box
								sx={{
									backgroundColor: "#c8e6d4",
									border: "3px solid #2F6B4F",
									borderRadius: "12px",
									padding: isSmallScreen ? "16px 20px" : "8px 12px",
									fontSize: 12,
									color: "#333",
								}}
							>
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: 1,
										fontSize: 13,
										fontWeight: 700,
										color: "#2F6B4F",
										textTransform: "uppercase",
									}}
								>
									{listBox.titulo}
								</Box>
								<Box
									component="ul"
									sx={{ margin: 0, paddingLeft: 2.5, lineHeight: 1.5 }}
								>
									{listBox.items.map((item, i) => (
										<Box
											component="li"
											key={i}
											dangerouslySetInnerHTML={{ __html: item }}
										/>
									))}
								</Box>
							</Box>
							{listBoxSticker && (
								<Box
									component="img"
									src={listBoxSticker}
									alt=""
									sx={{
										width: 120,
										position: "absolute",
										bottom: 0,
										right: isSmallScreen ? -30 : 0,
									}}
								/>
							)}
							{listBoxTip && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? 90 : 70,
										right: isSmallScreen ? 0 : 30,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "12px 12px 0 12px",
										padding: "10px 12px",
										fontSize: 11,
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: 160,
									}}
								>
									<span dangerouslySetInnerHTML={{ __html: listBoxTip }} />
								</Box>
							)}
						</Box>
					)}

				{(yellowBox?.content ||
					(yellowBox?.titulo && Array.isArray(yellowBox?.items))) && (
					<Box
						data-block-id="text-3"
						sx={{
							backgroundColor: "#fff3b0",
							border: "3px solid #d6b400",
							borderRadius: "12px",
							padding: "10px 12px",
							fontSize: 12,
							color: "#333",
							marginTop: 1.5,
							width: "100%",
						}}
					>
						{yellowBox.titulo && (
							<Box
								component="h3"
								sx={{ ...estiloH3, marginBottom: 1, color: "#d6b400" }}
							>
								{yellowBox.titulo}
							</Box>
						)}
						{yellowBox.content && (
							<span dangerouslySetInnerHTML={{ __html: yellowBox.content }} />
						)}
						{Array.isArray(yellowBox.items) && yellowBox.items.length > 0 && (
							<Box
								component="ul"
								sx={{
									paddingLeft: 2.25,
									margin: 0,
									lineHeight: 1.5,
									fontSize: 13,
								}}
							>
								{yellowBox.items.map((item, i) => (
									<Box
										component="li"
										key={i}
										sx={{ marginBottom: 0.5 }}
										dangerouslySetInnerHTML={{ __html: item }}
									/>
								))}
							</Box>
						)}
					</Box>
				)}

				<Box
					data-block-id="text-4"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1,
						marginTop: 1.5,
					}}
				>
					{blocks.map((block, idx) => {
						if (
							block.type === "listBlock" &&
							block.titulo &&
							Array.isArray(block.items)
						) {
							return (
								<Box
									key={idx}
									data-block-id={`text-${idx + 5}`}
									sx={{
										backgroundColor: "#c8e6d4",
										borderRadius: "12px",
										padding: 2.5,
										width: isSmallScreen ? "100%" : "100%",
									}}
								>
									<Box component="h3" sx={estiloH3}>
										{block.titulo}
									</Box>
									<Box
										component="ul"
										sx={{
											paddingLeft: 2.5,
											margin: 0,
											lineHeight: 1.6,
											fontSize: 13,
										}}
									>
										{block.items.map((item, i) => (
											<Box
												component="li"
												key={i}
												dangerouslySetInnerHTML={{ __html: item }}
											/>
										))}
									</Box>
								</Box>
							);
						}
						const blockImage = block.imageId
							? getImageSrc(block.imageId)
							: null;
						return (
							<Box
								key={idx}
								data-block-id={`text-${idx + 5}`}
								sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}
							>
								{blockImage && (
									<Box
										component="img"
										src={blockImage}
										alt=""
										sx={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
											flexShrink: 0,
										}}
									/>
								)}
								<Box sx={{ width: blockImage ? "60%" : "100%" }}>
									{block.titulo && (
										<Box component="h3" sx={estiloH3}>
											{block.titulo}
										</Box>
									)}
									{block.contenido && (
										<Box component="p" sx={estiloP}>
											{block.contenido}
										</Box>
									)}
								</Box>
							</Box>
						);
					})}
				</Box>

				{footerBox?.content && (
					<Box
						data-block-id="text-footer"
						sx={{
							backgroundColor: "#c8e6d4",
							border: "3px solid #2F6B4F",
							borderRadius: "12px",
							padding: "10px 16px",
							fontSize: 12,
							color: "#333",
							width: isSmallScreen ? "100%" : "100%",
							marginTop: isSmallScreen ? 8 : 1,
						}}
					>
						{footerBox.titulo && (
							<Box component="h3" sx={{ ...estiloH3, fontSize: 13 }}>
								{footerBox.titulo}
							</Box>
						)}
						<Box component="p" sx={{ ...estiloP, fontSize: 12 }}>
							{footerBox.content}
						</Box>
					</Box>
				)}

				{footerSticker && (
					<Box
						component="img"
						src={footerSticker}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? 70 : 50,
							left: -30,
						}}
					/>
				)}
				{footerTip && (
					<Box
						sx={{
							position: "absolute",
							bottom: isSmallScreen ? 140 : 130,
							left: 10,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px 12px 12px 0",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 120,
						}}
					>
						{footerTip}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template293.thumbnail = "/images/template-1.png";
export default Template293;
